// extracted by mini-css-extract-plugin
export default {"container":"znzjoW","sm":"r_JiRG","md":"cqx4YP","lg":"bPNmnI","headline-list-container":"ZimOt5","headlineListContainer":"ZimOt5","text":"R5d96z","cta":"fORUDs"};